// src/components/ReportIcon.js
import { motion } from "framer-motion";

export default function ReportIcon({ gradientId, glowColor }) {
  const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.2, delayChildren: 0.3 } },
  };
  const item = {
    hidden: { pathLength: 0, opacity: 0 },
    show: { pathLength: 1, opacity: 1, transition: { duration: 1.2, ease: "easeInOut" } },
  };
  const pulse = {
    hidden: { scale: 0.8, opacity: 0 },
    show: {
      scale: [1, 1.1, 1],
      opacity: [1, 0.7, 1],
      transition: { delay: 1, duration: 2, repeat: Infinity, ease: "easeInOut" },
    },
  };
  return (
    <motion.svg viewBox="0 0 100 100" variants={container} initial="hidden" animate="show">
      <defs>
        <filter id="glow">
          <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* 데이터 스트림 라인 */}
      <motion.path d="M10 20 C 30 20, 40 40, 50 50" stroke={`url(#${gradientId})`} {...item} />
      <motion.path d="M10 80 C 30 80, 40 60, 50 50" stroke={`url(#${gradientId})`} {...item} />
      <motion.path d="M90 20 C 70 20, 60 40, 50 50" stroke={`url(#${gradientId})`} {...item} />
      <motion.path d="M90 80 C 70 80, 60 60, 50 50" stroke={`url(#${gradientId})`} {...item} />
      {/* 중앙 코어 */}
      <motion.circle cx="50" cy="50" r="10" fill={`url(#${gradientId})`} variants={pulse} style={{ filter: 'url(#glow)' }}/>
    </motion.svg>
  );
}